<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">

        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Personel Information</span>
        </div>

        <!-- Col Content -->
        <div>

          <!-- DOB 
          <div class="mt-4">
            <label class="text-sm">Birth Date</label>
            <flat-pickr v-model="data_local.dob" :config="{ dateFormat: 'd F Y', maxDate: new Date() }" class="w-full" v-validate="'required'" name="dob" />
            <span class="text-danger text-sm"  v-show="errors.has('dob')">{{ errors.first('dob') }}</span>
          </div>
-->
          <vs-input class="w-full mt-4" label="Mobile" v-model="data_local.mobile" v-validate="{regex: '^\\+?([0-9]+)$' }" name="mobile" />
          <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>

          <vs-input class="w-full mt-4" label="email" v-model="data_local.email" v-validate="'required'" name="email" data-vv-as="email" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>

          <vs-input class="w-full mt-4" label="Bank" v-model="data_local.bank" v-validate="'required'" name="bank" data-vv-as="bank" />
          <span class="text-danger text-sm"  v-show="errors.has('bank')">{{ errors.first('bank') }}</span>

          <vs-input class="w-full mt-4" label="Rip" v-model="data_local.rip" v-validate="'required'" name="rip" data-vv-as="rip" />
          <span class="text-danger text-sm"  v-show="errors.has('rip')">{{ errors.first('rip') }}</span>

          <!-- Gender
          <div class="mt-4">
            <label class="text-sm">Gender</label>
            <div class="mt-2">
              <vs-radio v-model="data_local.gender" vs-value="male" class="mr-4">Male</vs-radio>
              <vs-radio v-model="data_local.gender" vs-value="female" class="mr-4">Female</vs-radio>
              <vs-radio v-model="data_local.gender" vs-value="other">Other</vs-radio>
            </div>
          </div> -->

          

        </div>
      </div>

      <!-- Address Col -->
      <div class="vx-col w-full md:w-1/2">

          <!-- Col Header -->
          <div class="flex items-end md:mt-0 mt-base">
            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">Address</span>
          </div>

          <!-- Col Content -->
          <vs-input class="w-full mt-4" label="adresse" v-model="data_local.adresse" v-validate="" name="adresse" data-vv-as="field" />
          <span class="text-danger text-sm"  v-show="errors.has('adresse')">{{ errors.first('adresse') }}</span>

          <div class="flex items-end  mt-5 ">
            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">Salaire</span>
          </div>

          <vs-checkbox class="mt-5 ml-2" v-model="data_local.salarie">Salarié</vs-checkbox>

          <vs-input-number class="mt-5 ml-2" v-if="data_local.salarie==1 || data_local.salarie" v-model="data_local.salaire" :step="10"/>

      </div>
      
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Sauvegarder</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Réinitialiser</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import moduledomaine from '@/store/domaine/moduledomaine.js'
import moduleformateur from '@/store/formateur/moduleformateur.js'
export default {
  components: {
    vSelect,
    flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

      data_local: JSON.parse(JSON.stringify(this.data[0])),

      langOptions: [
        { label: "English",  value: "english"  },
        { label: "Spanish",  value: "spanish"  },
        { label: "French",   value: "french"   },
        { label: "Russian",  value: "russian"  },
        { label: "German",   value: "german"   },
        { label: "Arabic",   value: "arabic"   },
        { label: "Sanskrit", value: "sanskrit" },
      ],
    }
  },
  computed: {
    
    validateForm() {
      return !this.errors.any()
    },
    
  },
  domaine_choices() {
        let opts=[];
          for (var domaine of this.$store.state.domaine.users) {
              opts.push({label: domaine.nom_domaine, value: domaine.nom_domaine});
              
            }
            console.log("1111111111111111111111111",this.$store.state.domaine.users)
            console.log("opts",opts)
      return opts
    },
  methods: {
    capitalize(str) {
      return str.slice(0,1).toUpperCase() + str.slice(1,str.length)
    },
    save_changes() {
      this.$store.dispatch("formateur/updateRecord", this.data_local).then(()   => { this.$store.dispatch("formateur/fetchUsers").catch(err => { console.error(err) }); this.$forceUpdate(); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('success', 'mise à jour', 'mise à jour réussie') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not update', 'an error in update: '+ err) }) 


    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'Formateur '+title,
                text: 'Formateur : '+text
              })
            },
    reset_data() {
      
      this.data_local = JSON.parse(JSON.stringify(this.data[0]))
      
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.data_local.avatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
    },
  created() {
    // Register Module UserManagement Module
    if(!moduleformateur.isRegistered) {
      this.$store.registerModule('formateur', moduleformateur)
      moduleformateur.isRegistered = true
    }
    this.$store.dispatch("formateur/fetchUsers").catch(err => { console.error(err) })


    if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
   this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) })
    },
}
</script>
